module.exports = __webpack_public_path__ + "static/media/sickleave.a3435827.svg";